import React, { useCallback, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { useFormikContext } from 'formik'
import _ from 'lodash'
import { fetch_address_list, fetch_address_details } from '../../../../../api'
import { FormattedMessage, useIntl } from 'react-intl'
import withOutClick from '../../../login/components/input/out-side-lick'
import { useEffect } from 'react'

export default withOutClick(props => {
    useStyles(classes)

    const intl = useIntl()

    const [suggestions, setSuggestions] = useState(null)
    const [value, setValue] = useState('')
    const [show, setShow] = useState(false)

    const {
        setFieldValue,
        values,
        setValues
    } = useFormikContext()


    useEffect(() => {
        setShow(false)
    }, [props.open])


    const onAddress = useCallback(address => {
        if (address) {
            setFieldValue('streetAddress1', address.streetAddress1||'')
            setFieldValue('zipCode', address.zipCode||'')
            setFieldValue('city', address.city||'')
            setFieldValue('state', address.state?.value||'')
            setFieldValue('country', address.country?.value||'')
        }
    }, [])

    const fetchSuggestions = useCallback(_.debounce(async (input, country, container) => {
        const response = await fetch_address_list({ input, country, container })
        if (response?.code === 200) {
            if(response?.result?.length > 0){
                setShow(true)
            }
            setSuggestions(response?.result)
        }
    }, 300), [])

    const handleChange = e => {
        setValue(e.target?.value)
        fetchSuggestions(e.target?.value, values?.country)
    }

    const handleClick = useCallback(async (address, input, country, e) => {
        e.stopPropagation()
       
        if (address.containerId) {
            fetchSuggestions(input, country, address.containerId)
        } else if (address.placeId) {
            const response = await fetch_address_details(address.placeId)
            if (response?.code === 200) {
                setValue(address?.description)
                props.onMaually(true)
                onAddress(response?.result)
                setShow(false)
            }
        }
    }, [])

    return <div className={classes.Container}>
        <input onChange={handleChange} value={value} placeholder={
            intl.formatMessage({ id: 'auto_search_address', defaultMessage: 'ADDRESS FINDER: Search by postcode, street or address' })
        } />
        {
            show && <div className={classes.SuggestionContainer}>
            <ul className={classes.Suggestions}>
                {
                    suggestions?.map?.(suggestion => <li onClick={(e) => { handleClick(suggestion, value, values.country, e) }} key={suggestion.containerId || suggestion.placeId}>
                        {suggestion.description}
                    </li>)
                }
            </ul>
            <div className={classes.NoResult} onClick={e => {
                setShow(false)
                props.onMaually(true)
            }}>
                <span>
                    <FormattedMessage id="cant_find_address" defaultMessage="Can't find the address"/>? 
                </span>
                {' '}
                <span style={{color: 'rgb(62, 116, 174)'}}>
                    <FormattedMessage id="enter_it_manually" defaultMessage="Enter it manually"/>
                </span>
            </div>
        </div>
        }
        
    </div>
})